import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CATEGORIES, CALCULATORS } from "../data/site";
import { ARTICLES, getArticlesByCategory } from "../data/articles";
import ArticleCard from "../components/ArticleCard";
import homevec from '../assets/finace.svg';

function Home() {
  const trending = getArticlesByCategory("trending").slice(0, 3);
  const featuredCalcs = CALCULATORS.slice(0, 6);

  return (
    <>
      {/* Hero (light, reference style) */}
      <section className="fi-home-hero">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={6}>
              <div className="eyebrow">Personal Finance &amp; Investing</div>
              <h1 className="mt-1">
                Master Your Money,<br />Build Lasting Wealth
              </h1>
              <p className="lead mt-3">
                Budgeting, investing, tax-saving and {CALCULATORS.length} free
                finance calculators everything you need to grow your wealth,
                explained simply. Trusted guidance for smarter money decisions.
              </p>
              <div className="d-flex flex-wrap gap-3 mt-4">
                <Button as={Link} to="/calculators" size="lg" className="btn-green rounded-3 px-4">
                  Try Free Calculators
                </Button>
                <Button
                  as={Link}
                  to="/category/education"
                  size="lg"
                  variant="outline-success"
                  className="rounded-3 px-4"
                >
                  Start Learning
                </Button>
              </div>
            </Col>
            <Col lg={6} className="text-end">
              {/* <HeroArt /> */}
              <img src={homevec} style={{height: "350px" }} alt="Financial Growth" className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </section>

      {/* About Us */}
      <section className="fi-about">
        <Container>
          <div className="text-center mb-4">
            <div className="fi-eyebrow">About Us</div>
            <h2 className="fi-about-heading">Your Trusted Finance Companion</h2>
          </div>
          <Row className="align-items-center g-5">
            <Col lg={6}>
              <p className="text-muted" style={{ fontSize: "1.08rem", lineHeight: 1.9 }}>
                We makes personal finance simple for everyone. From your
                first budget to your retirement corpus, we turn confusing money
                topics into clear, actionable steps backed by easy-to-use
                calculators and honest, jargon-free guides.
              </p>
              <p className="text-muted" style={{ fontSize: "1.08rem", lineHeight: 1.9 }}>
                Whether you're learning what a SIP is or comparing the old vs new
                tax regime, we're here to help you make confident decisions with
                your money no sales pitch, just knowledge.
              </p>
              <Button as={Link} to="/category/personal-finance" className="btn-green rounded-3 px-4 mt-2">
                Explore Guides
              </Button>
            </Col>
            <Col lg={6}>
              <Row className="g-4">
                <Col xs={6}>
                  <div className="fi-stat fi-about-stat p-4">
                    <div className="n">{ARTICLES.length}+</div>
                    <small className="text-muted">In-depth guides</small>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="fi-stat fi-about-stat p-4">
                    <div className="n">{CALCULATORS.length}</div>
                    <small className="text-muted">Free calculators</small>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="fi-stat fi-about-stat p-4">
                    <div className="n">{CATEGORIES.length}</div>
                    <small className="text-muted">Finance topics</small>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="fi-stat fi-about-stat p-4">
                    <div className="n">100%</div>
                    <small className="text-muted">Free &amp; unbiased</small>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Categories */}
      <Container className="py-5">
        <div className="text-center mb-4">
          <div className="fi-eyebrow">Explore</div>
          <h2 className="fi-section-title">Everything Finance, in One Place</h2>
          <p className="text-muted">Pick a topic and dive in.</p>
        </div>
        <Row className="g-4">
          {CATEGORIES.map((cat) => (
            <Col md={6} lg={4} key={cat.key}>
              <Link to={`/category/${cat.key}`} className="fi-cat-card text-decoration-none">
                <div
                  className="fi-cat-media"
                  style={{ backgroundImage: `url(${cat.banner})` }}
                >
                  {/* <span className="fi-cat-emoji">{cat.emoji}</span> */}
                </div>
                <div className="fi-cat-body">
                  <h5 className="title">{cat.label}</h5>
                  <p className="text-muted mb-3">{cat.blurb}</p>
                  <span className="fi-cat-link">Explore {cat.label} →</span>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Calculators */}
      <section style={{ background: "#fff" }} className="py-5">
        <Container>
          <div className="text-center mb-4">
            <div className="fi-eyebrow">Free Tools</div>
            <h2 className="fi-section-title"> Finance Calculators</h2>
            <p className="text-muted">Plan smarter with instant, accurate numbers.</p>
          </div>
          <Row className="g-4">
            {featuredCalcs.map((c) => (
              <Col md={6} lg={4} key={c.slug}>
                <Card as={Link} to={`/calculators/${c.slug}`} className="fi-calc-card text-decoration-none text-reset" style={{ "--c": c.color }}>
                  <Card.Body className="d-flex align-items-center gap-3">
                    <div className="fi-card-icon mb-0">{c.emoji}</div>
                    <div>
                      <div className="fw-bold">{c.title}</div>
                      <small className="text-muted">{c.desc}</small>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <div className="text-center mt-4">
            <Button as={Link} to="/calculators" className="btn-fi rounded-pill px-4">
              View all {CALCULATORS.length} calculators →
            </Button>
          </div>
        </Container>
      </section>

      {/* Trending */}
      <Container className="py-5">
        <div className="d-flex justify-content-between align-items-end mb-4">
          <div>
            {/* <div className="fi-eyebrow">🔥 Trending</div> */}
            <h2 className="fi-section-title">What Everyone's Reading</h2>
          </div>
          <Link to="/category/trending" className="fw-semibold" style={{ color: "var(--fi-primary)" }}>
            See all →
          </Link>
        </div>
        <Row className="g-4">
          {trending.map((a) => (
            <Col md={6} lg={4} key={a.slug}>
              <ArticleCard article={a} />
            </Col>
          ))}
        </Row>
      </Container>

      {/* Blog */}
      {/* <section style={{ background: "#fff" }} className="py-5">
        <Container>
          <div className="d-flex justify-content-between align-items-end mb-4">
            <div>
             
              <h2 className="fi-section-title">Real Money Questions, Answered</h2>
            </div>
            <Link to="/category/blog" className="fw-semibold" style={{ color: "var(--fi-primary)" }}>
              See all →
            </Link>
          </div>
          <Row className="g-4">
            {blog.map((a) => (
              <Col md={6} lg={3} key={a.slug}>
                <ArticleCard article={a} />
              </Col>
            ))}
          </Row>
        </Container>
      </section> */}

      {/* CTA */}
      <Container className="py-5">
        <div className="fi-calc-result text-center p-5">
          <h2 className="fw-bold">Start your wealth journey today</h2>
          <p className="lead mb-4 opacity-75">
            Knowledge is the best investment. Explore our guides and tools all free.
          </p>
          <Button as={Link} to="/category/education" size="lg" className="btn-fi rounded-pill px-4">
            Learn the Basics
          </Button>
        </div>
      </Container>
    </>
  );
}

export default Home;
